import { IClientFacetsConfig, IFiltersConfig, IFilterInitValue, IFilterGrouping } from '../interfaces';

export class FiltersConfig implements IFiltersConfig {
	baseUrl: string = null;
	initUrl: string = '/init';
	updateUrl: string = '/update';
	closed: boolean = false;
	keepSessionState: boolean = false;
	excludeFromSessionState?: string[] = [];
	initValues: IFilterInitValue[] = [];

	filterGroups?: IFilterGrouping[] = [];
	syncFilterKeys?: string[] = [];
	type: 'sidenav' | 'chip' = 'sidenav';
	canSwitchView: boolean = true;
	disabled: boolean = false;
	locked?: boolean = false;
	clientFacets?: IClientFacetsConfig<never>;
}
